<template>
<div>
  <h2 class="text-primary-dark seccion">Solicitar proyecto</h2>
  <div class="row stepper mb-3">
    <div class="col stepper-stage" :class="{ 'active' : stage == 1 }">
      <div class="stepper-stage-icon" :class="{ 'bg-primary' : stage == 1, 'bg-gris' : stage != 1 }"><font-awesome-icon icon="th-large"/></div>
      <div class="stepper-stage-text d-none d-md-block">Selección de tipo</div>
    </div>
    <div class="col stepper-stage" :class="{ 'active' : stage == 2 }">
      <div class="stepper-stage-icon" :class="{ 'bg-primary' : stage == 2, 'bg-gris' : stage != 2 }"><font-awesome-icon icon="pencil-alt"/></div>
      <div class="stepper-stage-text d-none d-md-block">Comentarios</div>
    </div>
    <div class="col stepper-stage" :class="{ 'active' : stage == 3 }">
      <div class="stepper-stage-icon" :class="{ 'bg-primary' : stage == 3, 'bg-gris' : stage != 3 }"><font-awesome-icon icon="check"/></div>
      <div class="stepper-stage-text d-none d-md-block">Solicitud completada</div>
    </div>
  </div>

  <!-- INNICIO STAGE 1 -->
  <div v-if="stage == 1">
    <h3 class="text-center text-primary-dark mb-0 pb-2 mb-2">Seleccione el tipo de seguro</h3>
    <div class="row">
      <div class="col col-md-6 col-lg-3 offset-lg-3 text-center">
        <div class="my-2 pt-3 btn btn-light" @click="seleccionarRamo('autos')">
          <img src="/clientes/ramos/autos.png" class="w-50"/>
          <p style="font-size: 2.2em">Autos</p>
        </div>
      </div>
      <div class="col col-md-6 col-lg-3 text-center">
        <div class="my-2 pt-3 btn btn-light" @click="seleccionarRamo('hogar')">
          <img src="/clientes/ramos/hogar.png" class="w-50"/>
          <p style="font-size: 2.2em">Hogar</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col col-md-6 col-lg-3 offset-lg-3 text-center">
        <div class="my-2 pt-3 btn btn-light" @click="seleccionarRamo('vida')">
          <img src="/clientes/ramos/vida.png" class="w-50"/>
          <p style="font-size:2.2rem">Vida</p>
        </div>
      </div>
      <div class="col col-md-6 col-lg-3 text-center">
        <div class="my-2 pt-3 btn btn-light" @click="seleccionarRamo('otros')">
          <img src="/clientes/ramos/otros.png" class="w-50"/>
          <p style="font-size: 2.2em">Otros</p>
        </div>
      </div>
    </div>
  </div>
  <!-- FIN STAGE 1 -->

  <!-- INICIO STAGE 2 -->
  <div v-if="stage == 2">
    <form @submit.prevent="solicitar()">
      <div class="row">
          <div class="col-md-12 form-group" v-if="clientes.length > 1">
            <label class="label-form">Cliente</label>
            <select v-model="cliente" class="form-control">
              <option v-for="cli in clientes" :key="cli.id" :value="cli.id">{{ cli.tomador }}</option>
            </select>
          </div>
          <div class="col-md-12 form-group" v-if="clientes.length == 1">
            <label class="label-ficha">Cliente</label>
            {{ clientes[0].tomador }}
          </div>
          <div class="col-md-12 form-group">
            <p class="lead font-weight-normal" v-if="nombreRamo != ''">Quiero solicitar la confección de un proyecto para mi seguro de {{ nombreRamo }}.</p>
            <label class="label-form" v-if="nombreRamo != ''">¿Quiere anotar alguna observación?</label>

            <p class="lead font-weight-normal" v-if="nombreRamo == ''">Quiero solicitar la confección de un proyecto para un seguro con las características que indico a continuación.</p>
            <label class="label-form" v-if="nombreRamo == ''">Características</label>
            <textarea v-model="observaciones" class="form-control"></textarea>
          </div>
          <div class="col-md-12 text-right">
            <button v-if="!sending" class="btn btn-primary">Solicitar</button>
            <button v-else class="btn btn-primary disabled" disabled><font-awesome-icon icon="spinner" class="fa-spin"/> Solicitando</button>
          </div>
      </div>
    </form>
  </div>
  <!-- FIN STAGE 2 -->

  <!-- INICIO STAGE 3 -->
  <div v-if="stage == 3">
    <div class="row">
      <div class="col-md-12">
        <p class="text-center"><font-awesome-icon icon="check" class="fa-5x text-success"/></p>
        <p class="lead font-weight-normal text-center">Gracias por solicitar su proyecto de seguro con nosotros.</p>
        <p class="text-center">En breve nuestros operadores comenzarán a gestionarlo.</p>
        <p class="text-center">
          <upload-documento tipoObjeto="160" :idObjeto="proyecto.id" texto="Adjuntar documento" 
            style="float: none!important" @uploaded="uploadDone()"/>
        </p>
        <p class="text-center font-weight-bold">Puede seguir el proceso en cualquier momento accediendo a la ficha del proyecto</p>
        <p class="text-center">
          <router-link :to="{ name: 'proyecto', params: { id: proyecto.id}}" class="btn btn-primary">
            <font-awesome-icon icon="file"/> Ficha del proyecto</router-link>
        </p>
      </div>
    </div>
  </div>
  <!-- FIN STAGE 3 -->
</div>
</template>

<script>
import UploadDocumento from '@/components/widgets/documentos/UploadDocumento'
import { mapGetters } from 'vuex'
import util from '@/util'
export default {
  data() {
    return {
      proyecto: null,
      clientes: [],
      cliente: null,
      ramo: null,
      descripcionRiesgo: '',
      etapa: null,
      ejecutivo: null,
      tipo: null,
      observaciones: '',
      sending: false,
      stage: 1,
      nombreRamo: ''
    }
  },
  computed: {
    ...mapGetters({
      urlBase: 'urlBase',
      credentials: 'credentials',
      parametros: 'parametros'
    })
  },
  mounted() {
    if (!this.parametros.etapa_defecto || ! this.parametros.ejecutivo_defecto || !this.parametros.tipo_opt_cliente) {
      alert("La configuración del sistema no permite solicitar nuevos proyectos.");
      return;
    }
    this.etapa = this.parametros.etapa_defecto
    this.ejecutivo = this.parametros.ejecutivo_defecto
    this.tipo = this.parametros.tipo_opt_cliente
    this.getClientes()
  },
  methods: {
    solicitar() {
      this.sending = true;
      let url = this.urlBase + 'oportunidades'
      let options = {}
      let data = {
        cliente: this.cliente,
        ramo: this.ramo,
        descripcionRiesgo: this.descripcionRiesgo,
        etapa: this.etapa,
        ejecutivo: this.ejecutivo,
        observaciones: this.observaciones
      }
      this.$http.post(url, data, options).then(
          (response) => {
            this.proyecto = response.body
            this.sending = false
            this.stage = 3
          },
          (error) => {
            console.log(error)
            this.sending = false
            if (error.status === 401) {
              this.$router.push({name:'Login'})
            }
          }
      )
    },
    seleccionarRamo(tipo) {
      this.stage = 2
      switch(tipo) {
        case 'autos':
          this.ramo = this.parametros.ramo_autos
          this.descripcionRiesgo = 'AUTOS'
          this.nombreRamo = "autos"
          break;
        case 'hogar':
          this.ramo = this.parametros.ramo_hogar
          this.descripcionRiesgo = 'HOGAR'
          this.nombreRamo = "hogar"
          break;
        case 'vida':
          this.ramo = this.parametros.ramo_vida
          this.descripcionRiesgo = 'VIDA'
          this.nombreRamo = "vida"
          break;
        default:
          this.ramo = this.parametros.ramo_rc
          this.descripcionRiesgo = 'OTROS'
          this.nombreRamo = ""
          break;
      }
    },
    getClientes() {
       // Obtener datos del cliente para rellenarlos en el form
      let grupos = [
          'cliente.domiciliaciones'
      ]
      let params = {
          'grupos': grupos.join(',')
      }
      let url = this.urlBase + 'clientes?' + util.objToQuery(params);

      this.$http.get(url).then(
          (response) => {
            this.clientes = response.body.items
            for (let i = 0; i < this.clientes.length; i++) {
              if (parseInt(this.clientes[i].id) == parseInt(this.credentials.id)) {
                this.cliente = this.clientes[i].id
              }
            }
          },
          (error) => {
          }
      );
    },
    uploadDone() {
      alert("Se ha adjuntado el documento al proyecto.")
    }
  },
  components: {
    UploadDocumento
  }
}
</script>

<style>

</style>
